import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(3 2.25)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M9.75 4C11.2688 4 12.5 5.23122 12.5 6.75V16.75C12.5 18.2688 11.2688 19.5 9.75 19.5H2.75C1.23122 19.5 0 18.2688 0 16.75V6.75C0 5.23122 1.23122 4 2.75 4H9.75ZM2.75 5.5C2.05964 5.5 1.5 6.05964 1.5 6.75V16.75C1.5 17.4404 2.05964 18 2.75 18H9.75C10.4404 18 11 17.4404 11 16.75V6.75C11 6.05964 10.4404 5.5 9.75 5.5H2.75ZM15.25 0C16.7688 0 18 1.23122 18 2.75V12.25C18 13.7688 16.7688 15 15.25 15H14.75V13.5H15.25C15.9404 13.5 16.5 12.9404 16.5 12.25V2.75C16.5 2.05964 15.9404 1.5 15.25 1.5H8.9375C8.41973 1.5 8 1.91973 8 2.4375H6.5C6.5 1.09131 7.59131 0 8.9375 0H15.25Z",
			fill: "currentColor"
		})
	})
});
export default SvgCopy;
